import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { AlertTriangle, X } from 'lucide-react'
import { isSupabaseConfigured } from '../lib/supabase'

export function DemoBanner() {
  const [isVisible, setIsVisible] = useState(!isSupabaseConfigured)

  if (!isVisible || isSupabaseConfigured) {
    return null
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -50 }}
        className="bg-gradient-to-r from-yellow-600 to-orange-600 text-white px-4 py-3 relative"
      >
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <AlertTriangle className="w-5 h-5 flex-shrink-0" />
            <div className="text-sm">
              <strong>Modo Demo:</strong> Supabase não configurado. 
              Algumas funcionalidades estão simuladas. 
              <a 
                href="#configuracao" 
                className="underline ml-1 hover:text-yellow-200"
              >
                Ver instruções de configuração
              </a>
            </div>
          </div>
          
          <button
            onClick={() => setIsVisible(false)}
            className="text-white hover:text-yellow-200 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  )
}